// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"5932311b","732":"3569d508"}[chunkId] + ".chunk.css";
};